// // StripePaymentComponent.jsx
// import React, { useEffect, useState } from 'react';
// import { loadStripe } from '@stripe/stripe-js';
// import { Elements } from '@stripe/react-stripe-js';
// // import axios from 'axios';
// import axiosInstance from '../../api/AxiosInstance';
// import CheckoutForm from './CheckoutForm';

// // Load Stripe publishable key
// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// const StripePaymentComponent = ({ orderId, amount, userId, onPaymentSuccess, setShowStripeForm, setCompletePayment }) => {
//     console.log('loaded stripe')
//     const [clientSecret, setClientSecret] = useState('');
//     const [showPaymentForm, setShowPaymentForm] = useState(false);

//     const handleStartPayment = async () => {
//         try {
//             const res = await axiosInstance.post('https://farmers.csdevhub.com/admin/api/payment', {
//                 amount: amount, // Convert to paise
//                 userId,
//                 orderId,
//             });

//             console.log(res, "res")
//             setClientSecret(res.data.data);
//             setShowPaymentForm(true);
//         } catch (err) {
//             console.log('Payment Intent creation failed:', err);
//         }
//     };

//     const appearance = { theme: 'stripe' };
//     const options = { clientSecret, appearance };

//     console.log({ clientSecret })

//     return (
//         <>
//             {!showPaymentForm ? (
//                 <button className="primary-btn fs-14 py-2" onClick={handleStartPayment}>
//                     Pay
//                 </button>
//             ) : (
//                 clientSecret && (
//                     <Elements options={options} stripe={stripePromise}>
//                         <CheckoutForm orderId={orderId} onPaymentSuccess={onPaymentSuccess} setCompletePayment={setCompletePayment} setShowStripeForm={setShowStripeForm} />
//                     </Elements>
//                 )
//             )}

//             {/* {clientSecret && (
//                 <Elements options={options} stripe={stripePromise}>
//                     <CheckoutForm orderId={orderId} onPaymentSuccess={onPaymentSuccess} />
//                 </Elements>
//             )
//             } */}
//         </>
//     );
// };

// export default StripePaymentComponent;



import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import axiosInstance from '../../api/AxiosInstance';
import CheckoutForm from './CheckoutForm';
import { PulseLoader } from 'react-spinners';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const StripePaymentComponent = ({ orderId, amount, userId, onPaymentSuccess, setShowStripeForm, setCompletePayment }) => {
    const [clientSecret, setClientSecret] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const navType = window.performance.getEntriesByType("navigation")[0]?.type;

        if (navType === 'back_forward' || navType === 'reload') {
            const paymentFlag = localStorage.getItem('paymentInProgress');
            if (paymentFlag === 'true') {
                // Prevent re-rendering form
                setShowStripeForm(false);
                return;
            }
        }

        const handleStartPayment = async () => {
            try {
                const res = await axiosInstance.post('https://farmers.csdevhub.com/admin/api/payment', {
                    amount,
                    userId,
                    orderId,
                });
                setClientSecret(res.data.data);
            } catch (err) {
                console.error('Payment Intent creation failed:', err);
            } finally {
                setLoading(false);
            }
        };

        handleStartPayment();
    }, [amount, userId, orderId, setShowStripeForm]);



    const appearance = { theme: 'stripe' };
    const options = { clientSecret, appearance };

    if (loading) {
        return (
            // <div style={{
            //     height: '100vh',
            //     display: 'flex',
            //     justifyContent: 'center',
            //     alignItems: 'center'
            // }}>
            //     <div className="spinner-border text-primary" role="status">
            //         <span className="visually-hidden">Loading...</span>
            //     </div>
            // </div>

            <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
                <PulseLoader size={25} color="#0f0a30" />
            </div>
        );
    }

    return (
        <>
            {clientSecret && (
                <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm
                        orderId={orderId}
                        onPaymentSuccess={onPaymentSuccess}
                        setCompletePayment={setCompletePayment}
                        setShowStripeForm={setShowStripeForm}
                    />
                </Elements>
            )}
        </>
    );
};

export default StripePaymentComponent;
